import { indexOf, some, compact } from 'lodash';

const menus = [
  {
    keys: ['buyer_decisions', 'customer_experience', 'progress_dashboard', 'dashboard'],
    label: 'Feedback',
    url: '/feedback',
    componentKey: 'feedback',
  },
  {
    keys: ['leaderboard_leader', 'leaderboard_naughty'],
    label: 'Leaderboards',
    url: '/leaderboards',
    componentKey: 'leaderboards',
  },
  {
    keys: ['workspace'],
    label: 'Workspace',
    url: '/workspace',
    componentKey: 'workspace',
  },
  {
    keys: ['outcomes'],
    label: 'Outcomes',
    url: '/outcomes',
    componentKey: 'outcomes',
  },
  {
    keys: ['pipeline'],
    label: 'Pipeline',
    url: '/pipeline',
    componentKey: 'pipeline',
  },
  {
    keys: ['forecast'],
    label: 'Forecast',
    url: '/forecast',
    componentKey: 'forecast',
  },
  {
    keys: ['performance'],
    label: 'Performance',
    url: '/performance',
    componentKey: 'performance',
  },
  {
    keys: ['nominations'],
    label: 'Nominations',
    url: '/nominations',
    componentKey: 'nominations',
  },
];

export default (user, organization, canSeeAllPages) => {
  if (user._id) {
    const organizationRole = user.organization_role;
    const organizationRules = organization ? organization.role_access_rules || {} : {};
    const organizationRoleRules = organizationRules[organizationRole] || {};
    const features = organization ? organization.features : {};
    return compact(menus.map((menu) => {
      const siteEnabled = some(menu.keys, k => features[k] === true);
      const permissionEnabled = some(menu.keys, k => indexOf(['ALL', 'OWNERSHIP'], organizationRoleRules[k]) >= 0);
      const featureEnabled = siteEnabled && permissionEnabled;
      if ((canSeeAllPages || featureEnabled)) {
        return menu;
      }
      return null;
    }));
  }
  return [];
};

